import { CLOSE_SIDEVIEW } from '../constants'

export default () => ({
    type: CLOSE_SIDEVIEW
})
